import { ElMessageBox, ElNotification } from 'element-plus';

export const toast = {
  error: (msg: string) => {
    ElNotification({
      title: '错误',
      message: msg,
      type: 'error'
    })
  },
  warn: (msg: string) => {
    ElNotification({
      title: '警告',
      message: msg,
      type: 'warning'
    })
  },
  success: (msg: string) => {
    ElNotification({
      title: '成功',
      message: msg,
      type: 'success'
    })
  },
  info: (msg: string) => {
    ElNotification({
      title: '消息',
      message: msg,
      type: 'info'
    })
  }
}

export function deleteBox() {
  return ElMessageBox.confirm(
    '是否确认删除选中的数据？',
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
}

export function warningBox(message: string) {
  return ElMessageBox.confirm(
    message,
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
}